export const ApiConfig = {
  api: '/maxphone',
};
